import { BrowseFeedbackSentiment } from '@cartwhl/common/api/postBrowseFeedback';
import postBrowseFeedback from '@cartwhl/common/api/postBrowseFeedback';
import { BrowseResultItem, Feedback } from '@cartwhl/common/types';
import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import DownvoteFullIcon from '@cartwhl/ui/icons/DownvoteFullIcon';
import DownvoteIcon from '@cartwhl/ui/icons/DownvoteIcon';
import ThreeDotsIcon from '@cartwhl/ui/icons/ThreeDotsIcon';
import UpvoteFullIcon from '@cartwhl/ui/icons/UpvoteFullIcon';
import UpvoteIcon from '@cartwhl/ui/icons/UpvoteIcon';
import Button from '@cartwhl/ui/input/Button';

import { navigationStore } from 'stores';

import { useLibraryStore } from '../useLibraryStore';

type Props = {
  video: BrowseResultItem;
  onBrowseChoice: (video: BrowseResultItem) => void;
};

export default function BrowseMotionFeedbackMenu({
  video,
  onBrowseChoice,
}: Props) {
  const { positives, negatives, addPositiveFeedback, addNegativeFeedback } =
    useLibraryStore();

  return (
    <Dropdown
      side="top"
      trigger={
        <Button
          variant="secondary"
          size="sm"
          className="pointer-events-auto"
          icon={<ThreeDotsIcon />}
        />
      }
    >
      <Dropdown.Item
        icon={
          positives.has(video.jobID) ? (
            <UpvoteFullIcon className="text-green-500" />
          ) : (
            <UpvoteIcon />
          )
        }
        onClick={async () => {
          const payload: Feedback = {
            jobID: video.jobID,
            animationNumber: '0',
            sentiment: 'positive',
            mp4Path: video.mp4Path,
            prompt: video.title,
          };
          navigationStore.setFeedbackModal(payload);
          addPositiveFeedback(video.jobID);
          const { error } = await postBrowseFeedback({
            jobID: video.jobID,
            sentiment: BrowseFeedbackSentiment.UPVOTES,
            reason: '',
          });
          if (error) {
            console.error(error);
          }
        }}
      >
        {positives.has(video.jobID) ? 'Reported as great' : 'Report great'}
      </Dropdown.Item>
      <Dropdown.Item
        icon={
          negatives.has(video.jobID) ? (
            <DownvoteFullIcon className="text-red-500" />
          ) : (
            <DownvoteIcon />
          )
        }
        onClick={async () => {
          const payload: Feedback = {
            jobID: video.jobID,
            animationNumber: '0',
            sentiment: 'negative',
            mp4Path: video.mp4Path,
            prompt: video.title,
          };
          navigationStore.setFeedbackModal(payload);
          addNegativeFeedback(video.jobID);
          const { error } = await postBrowseFeedback({
            jobID: video.jobID,
            sentiment: BrowseFeedbackSentiment.DOWNVOTES,
            reason: '',
          });
          if (error) {
            console.error(error);
          }
        }}
      >
        {negatives.has(video.jobID) ? 'Reported as broken' : 'Report broken'}
      </Dropdown.Item>
    </Dropdown>
  );
}
